import { Ban, CheckCircle2, Eye, MoreHorizontal, Trash2, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { L } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const STATUS_ACTIONS = [
  { status: "approved", label: "Approve", pt: "Aprovar", icon: CheckCircle2, cls: "text-emerald-400" },
  { status: "rejected", label: "Reject", pt: "Rejeitar", icon: XCircle, cls: "text-slate-300" },
  { status: "blocked", label: "Block", pt: "Bloquear", icon: Ban, cls: "text-rose-400" },
];

export const UserActions = ({ user, isSelf, onRequest }) => {
  const navigate = useNavigate();
  const item = "gap-2 cursor-pointer focus:bg-slate-800";
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        className="p-1.5 rounded-md text-slate-400 hover:text-amber-400 hover:bg-slate-800/60 transition-colors outline-none"
        data-testid={`user-actions-trigger-${user.id}`}
        aria-label={L("Actions", "Ações")}
      >
        <MoreHorizontal className="h-4 w-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 bg-[#0f172a] border-slate-700 text-slate-200">
        <DropdownMenuItem className={item} onSelect={() => navigate(`/users/${user.id}`)} data-testid={`user-action-view-${user.id}`}>
          <Eye className="h-4 w-4 text-slate-400" /> {L("View details", "Ver detalhes")}
        </DropdownMenuItem>
        <DropdownMenuSeparator className="bg-slate-800" />
        {STATUS_ACTIONS.map(({ status, label, pt, icon: Icon, cls }) => (
          <DropdownMenuItem
            key={status}
            className={item}
            disabled={user.status === status || isSelf}
            onSelect={() => onRequest({ type: "status", status, user })}
            data-testid={`user-action-${status}-${user.id}`}
          >
            <Icon className={`h-4 w-4 ${cls}`} /> {L(label, pt)}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator className="bg-slate-800" />
        <DropdownMenuItem
          className={`${item} text-rose-400 focus:text-rose-300`}
          disabled={isSelf}
          onSelect={() => onRequest({ type: "delete", user })}
          data-testid={`user-action-delete-${user.id}`}
        >
          <Trash2 className="h-4 w-4" /> {L("Delete", "Eliminar")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
